module.exports = __webpack_public_path__ + "media/images/icon_info-f0f52a31.png";